// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconSymbolsClose_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s8IconSvg = html `<svg viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M3.99908 5.06169L1.52941 7.53136L0.46875 6.4707L2.93842 4.00103L0.46875 1.53136L1.52941 0.470703L3.99908 2.94037L6.46875 0.470703L7.52941 1.53136L5.05974 4.00103L7.52941 6.4707L6.46875 7.53136L3.99908 5.06169Z" class="svg-bg"/>
</svg>
`;
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M5.99617 7.41429L2.20328 11.2072L0.789062 9.79297L4.58196 6.00008L0.789062 2.20718L2.20328 0.792969L5.99617 4.58586L9.78906 0.792969L11.2033 2.20718L7.41038 6.00008L11.2033 9.79297L9.78906 11.2072L5.99617 7.41429Z" class="svg-bg"/>
</svg>
`;
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M6.5844 8.00007L1.29151 2.70718L2.70572 1.29297L7.99861 6.58586L13.2915 1.29297L14.7057 2.70718L9.41282 8.00007L14.7057 13.293L13.2915 14.7072L7.99861 9.41429L2.70572 14.7072L1.2915 13.293L6.5844 8.00007Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M10.2318 12.004L1.61572 3.38788L3.38349 1.62012L11.9996 10.2362L20.6157 1.62012L22.3835 3.38789L13.7674 12.004L22.3835 20.6201L20.6157 22.3879L11.9996 13.7718L3.38349 22.3879L1.61573 20.6201L10.2318 12.004Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M13.881 15.9972L1.94165 4.05784L4.06297 1.93652L16.0023 13.8759L27.9416 1.93653L30.063 4.05785L18.1236 15.9972L30.063 27.9365L27.9417 30.0578L16.0023 18.1185L4.06297 30.0578L1.94165 27.9365L13.881 15.9972Z" class="svg-bg"/>
</svg>
`;
/**
 * IconSymbolsClose is a generated icon component.
 */
let IconSymbolsClose = IconSymbolsClose_1 = class IconSymbolsClose extends IconBaseElement {
    render() {
        return html `${IconSymbolsClose_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconSymbolsClose.icons = new Map([
    ['s8', _s8IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconSymbolsClose = IconSymbolsClose_1 = __decorate([
    customElement('zui-icon-symbols-close')
], IconSymbolsClose);
export { IconSymbolsClose };
